import React, { useCallback, useState } from 'react';
import css from './styles.module.scss';
import { StepControls } from '~/common/step-controls';
import { Controller, useForm } from 'react-hook-form';
import { INewDealStepThreeFormInputs } from '~/models/deals/new-deal/formInputs';
import { useThunkDispatch } from '~/utils/hooks/useThunkDispatch';
import { Box, Button, Grid, Switch, Typography } from '@material-ui/core';
import { newDealFormNextStep } from '~/features/dashboard/store/actions';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import classNames from 'classnames';
import { TextInput } from '~/features/dashboard/components/add-deal/components/text-input';

interface Step_3Props {
    prevStep: () => void;
}

enum SECTION_TYPES {
    PHYSICAL,
    DIGITAL,
}

export const Step_3: React.FC<Step_3Props> = ({ prevStep }) => {
    const [activeSection, setActiveSection] = useState<number>(SECTION_TYPES.PHYSICAL);
    const dispatch = useThunkDispatch();

    const {
        handleSubmit,
        register,
        setValue,
        control,
    } = useForm<INewDealStepThreeFormInputs>({
        defaultValues: {},
    });

    const onSubmit = useCallback(
        (data: INewDealStepThreeFormInputs) => {
            dispatch(newDealFormNextStep());
        },
        [dispatch]
    );

    return (
        <div className={css.module}>
            <form className={css.form} onSubmit={handleSubmit(onSubmit)}>
                <Typography align={'left'} variant={'h6'} className={classNames(css.bold, css.title)}>
                    test - test the Statement Received
                </Typography>
                <Box display="flex" justifyContent="center">
                    <ToggleButtonGroup
                        value={Number(activeSection)}
                        exclusive
                        onChange={(omit, value) => setActiveSection(value)}
                        aria-label="toggle data view"
                        className={css.toggleButtonGroup}
                    >
                        <ToggleButton value={SECTION_TYPES.PHYSICAL} aria-label="contacts view">
                            Physical
                        </ToggleButton>
                        <ToggleButton value={SECTION_TYPES.DIGITAL} aria-label="address view">
                            Digital
                        </ToggleButton>
                    </ToggleButtonGroup>
                </Box>
                {Number(activeSection) === SECTION_TYPES.DIGITAL ? (
                    <Grid container spacing={3}>
                        <Grid item xs={2} className={css.box}>
                            <label className="customlabel bold">Gross Digital</label>
                        </Grid>
                        <Grid item xs={8} className={css.box}>
                            <TextInput className={css.textInput} label={''} name={'usersRef'} register={register} />
                            <label className="customlabel bold">Net Digital</label>
                            <TextInput className={css.textInput} label={''} name={'usersRef'} register={register} />
                            <label className="customlabel bold">Matches Statement</label>
                        </Grid>
                        <Grid item xs={2} className={css.box}>
                            <div className={'inputcustom-outer switch-custom-outer'} style={{ display: 'flex', alignItems: 'center' }}>
                                <span>No</span>
                                <Controller
                                    name="isBilling"
                                    control={control}
                                    render={props => {
                                        return (
                                            <Switch
                                                id="e-book-switch1"
                                                type="checkbox"
                                                name="isBilling"
                                                onChange={e => setValue('isBilling', e.target.checked)}
                                                value={props.value}
                                                checked={props.value}
                                            />
                                        );
                                    }}
                                />
                                <span> Yes</span>
                            </div>
                        </Grid>

                        <Grid item xs={2} className={css.box}>
                            <label className="customlabel bold">Distribution Fee</label>
                            <label className="customlabel bold">%</label>
                        </Grid>
                        <Grid item xs={3}>
                            <TextInput
                                className={css.textInput}
                                label={''}
                                name={'usersRef'}
                                register={register}
                                // fieldError={errors.usersRef}
                            />
                        </Grid>
                        <Grid item xs={5} className={css.box}>
                            <TextInput
                                className={css.textInput}
                                label={''}
                                name={'usersRef'}
                                register={register}
                                // fieldError={errors.usersRef}
                            />
                        </Grid>
                        <Grid item xs={2} className={css.box}>
                            <Button className={css.button}>Details</Button>
                        </Grid>

                        <Grid item xs={2} className={css.box}>
                            <label className="customlabel bold">Reserves</label>
                            <label className="customlabel bold">%</label>
                        </Grid>
                        <Grid item xs={3}>
                            <TextInput
                                className={css.textInput}
                                label={''}
                                name={'usersRef'}
                                register={register}
                                // fieldError={errors.usersRef}
                            />
                        </Grid>
                        <Grid item xs={5} className={css.box}>
                            <TextInput
                                className={css.textInput}
                                label={''}
                                name={'usersRef'}
                                register={register}
                                // fieldError={errors.usersRef}
                            />
                        </Grid>
                        <Grid item xs={2} className={css.box}>
                            <Button className={css.button}>Details</Button>
                        </Grid>

                        <Grid item xs={2} className={css.box}>
                            <label className="customlabel bold">Other Deductions</label>
                        </Grid>
                        <Grid item xs={3}>
                            <TextInput className={css.textInput} label={''} name={'usersRef'} register={register} />
                        </Grid>
                        <Grid item xs={5} className={css.box}>
                            <TextInput className={css.textInput} label={''} name={'usersRef'} register={register} />
                        </Grid>
                        <Grid item xs={2} className={css.box}>
                            <Button className={css.button}>Details</Button>
                        </Grid>
                    </Grid>
                ) : (
                    <Grid container spacing={3}>
                        <Grid item xs={2} className={css.box}>
                            <label className="customlabel bold">Gross Physical</label>
                        </Grid>
                        <Grid item xs={8} className={css.box}>
                            <TextInput
                                className={css.textInput}
                                label={''}
                                name={'usersRef'}
                                register={register}
                                // fieldError={errors.usersRef}
                            />
                            <label className="customlabel bold">Net Physical</label>
                            <TextInput
                                className={css.textInput}
                                label={''}
                                name={'usersRef'}
                                register={register}
                                // fieldError={errors.usersRef}
                            />
                            <label className="customlabel bold">Matches Statement</label>
                        </Grid>
                        <Grid item xs={2} className={css.box}>
                            <div className={'inputcustom-outer switch-custom-outer'} style={{ display: 'flex', alignItems: 'center' }}>
                                <span>No</span>
                                <Controller
                                    name="isBilling"
                                    control={control}
                                    render={props => {
                                        return (
                                            <Switch
                                                id="e-book-switch1"
                                                type="checkbox"
                                                name="isBilling"
                                                onChange={e => setValue('isBilling', e.target.checked)}
                                                value={props.value}
                                                checked={props.value}
                                            />
                                        );
                                    }}
                                />
                                <span> Yes</span>
                            </div>
                        </Grid>

                        <Grid item xs={2} className={css.box}>
                            <label className="customlabel bold">Distribution Fee</label>
                            <label className="customlabel bold">%</label>
                        </Grid>
                        <Grid item xs={3}>
                            <TextInput className={css.textInput} label={''} name={'usersRef'} register={register} />
                        </Grid>
                        <Grid item xs={5} className={css.box}>
                            <TextInput className={css.textInput} label={''} name={'usersRef'} register={register} />
                        </Grid>
                        <Grid item xs={2} className={css.box}>
                            <Button className={css.button}>Details</Button>
                        </Grid>

                        <Grid item xs={2} className={css.box}>
                            <label className="customlabel bold">Reserves</label>
                            <label className="customlabel bold">%</label>
                        </Grid>
                        <Grid item xs={3}>
                            <TextInput className={css.textInput} label={''} name={'usersRef'} register={register} />
                        </Grid>
                        <Grid item xs={5} className={css.box}>
                            <TextInput className={css.textInput} label={''} name={'usersRef'} register={register} />
                        </Grid>
                        <Grid item xs={2} className={css.box}>
                            <Button className={css.button}>Details</Button>
                        </Grid>

                        <Grid item xs={2} className={css.box}>
                            <label className="customlabel bold">Other Deductions</label>
                        </Grid>
                        <Grid item xs={3}>
                            <TextInput
                                className={css.textInput}
                                label={''}
                                name={'usersRef'}
                                register={register}
                                // fieldError={errors.usersRef}
                            />
                        </Grid>
                        <Grid item xs={5} className={css.box}>
                            <TextInput
                                className={css.textInput}
                                label={''}
                                name={'usersRef'}
                                register={register}
                                // fieldError={errors.usersRef}
                            />
                        </Grid>
                        <Grid item xs={2} className={css.box}>
                            <Button className={css.button}>Details</Button>
                        </Grid>
                    </Grid>
                )}
                <StepControls onPrevClick={prevStep} className={css.nextButton} />
            </form>
        </div>
    );
};
